
import React, { Component } from 'react';
import './delete-section.scss'
import { Modal, ModalBody } from "reactstrap";
import { ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown';
import SchoolUserApi from '../../../apis/student'
import SessionCache from '../../routes/session-cache';

class DeleteTeacher extends Component {

    state = {
        studentList: [],
        sectionDropdown: []
    }
    componentDidMount() {
        this.user = SessionCache.getUser()
        this.getStudent()
        this.getSections()
    }

    getStudent() {
        let payload = {
            class: this.props.section?.class,
            board: this.props.section?.board,
            section: this.props.section?.section,
        }
        SchoolUserApi.getSchoolUsers(payload)
            .then(response => {
                let studentList = response?.response || []
                studentList.forEach(item => {
                    delete item.sectionId
                    delete item.section
                })
                this.setState({ studentList })
            }).catch(err => {
                this.setState({ studentList: [] })
            })
    }

    getSections() {
        let payload = {
            class: this.props.section?.class,
            board: this.props.section?.board,
        }
        SchoolApi.getSections(payload)
            .then(response => {
                let section = response?.response
                let sectionDropdown = []
                section.forEach(element => {
                    if (element._id === this.props.section?._id) return
                    sectionDropdown.push({
                        title: element.section,
                        value: element._id,
                    })
                });

                this.setState({ sectionDropdown, reloadDropdown: true }, () => {
                    this.setState({ reloadDropdown: false })
                })
            }).catch(err => {
            })
    }


    onClickDelete = () => {
        let { payload, validation } = this.preparePayload()
        if (!validation) {
            this.setState({ isSubmit: true })
            return
        }
        let obj = {
            _id: this.props.section?._id,
            students: payload
        }

        SchoolApi.deleteSchoolSection(obj)
            .then(response => {
                this.props.onOk && this.props.onOk()
            }).catch(err => {
                console.log(err)
            })

    }


    preparePayload() {
        let result = [], validation = true
        let studentList = this.state.studentList
        for (let i = 0; i < studentList.length; i++) {
            let student = studentList[i]
            let payload = {
                id: student._id,
                sectionId: student.sectionId,
                section: student.section
            }
            if (!payload.sectionId) validation = false
            result.push(payload)
        }
        return { payload: result, validation }
    }

    onTimeValidation() {
        let { validation } = this.preparePayload()
        this.setState({ validation })
    }


    onSelectSection(option, index) {
        let studentList = this.state.studentList
        if (!this.state.selectAll) {
            studentList[index].sectionId = option?.value || null
            studentList[index].section = option?.title || null
        } else {
            for (let i = 0; i < studentList.length; i++) {
                studentList[i].sectionId = option?.value || null
                studentList[i].section = option?.title || null
            }
        }
        this.setState({ studentList, reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
            this.onTimeValidation()
        })
    }

    onClickContinue = () => {
        this.setState({ isContinue: true })
    }

    render() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.props.close} size={this.state.isContinue ? 'lg' : "md"}>

                <ModalBody >
                    <div className="delete-section">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.close} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>

                        {
                            !this.state.isContinue ?
                                <div >
                                    <div className="text-center">
                                        <div className="title">Before deleting section {this.props.section?.section || ""}, Assign all the students to another section </div>
                                    </div>
                                    <div className="text-center pt-5 pb-4">
                                        <button className="cw-button-primary light mr-2" onClick={this.props.close}>Cancel</button>
                                        <button className="cw-button-primary" onClick={this.onClickContinue}>Continue </button>
                                    </div>
                                </div>
                                :

                                <div className="px-4">
                                    <div className="text-center">
                                        <div className="title">Assign following students to another section</div>
                                    </div>
                                    <div id="table-scoll" className="table-responsive mt-4 px-4 padding-bottom">
                                        <table className="table cw-table bordered-table">
                                            <thead>
                                                <tr>
                                                    <th className='th-left-radius text-center'>
                                                        {
                                                            !this.state.selectAll ?
                                                                <img className="rect-box" src={getImageSource(ImageConstants.RECT)} onClick={() => { this.setState({ selectAll: !this.state.selectAll }) }} />
                                                                : <img className="rect-box" src={getImageSource(ImageConstants.RECT_TICK)} onClick={() => { this.setState({ selectAll: !this.state.selectAll }) }} />
                                                        }

                                                    </th>
                                                    <th>Student</th>
                                                    <th>Roll No</th>
                                                    <th className="th-right-radius">New Section</th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white">
                                                {
                                                    this.state.studentList?.length ?
                                                        this.state.studentList.map((item, index) => (

                                                            <tr className="mt-4 tr-border">
                                                                <td className="text-center">
                                                                    {
                                                                        this.state.selectAll ?
                                                                            <div className=' active-checkbox d-inline-block' onClick={this.onClickAllCheckBox}>
                                                                                <img className="rect-box" src={getImageSource(ImageConstants.RECT_TICK)} />
                                                                            </div>
                                                                            : ""
                                                                    }</td>
                                                                <td className="">
                                                                    <div className="name-text">{item.name}</div>
                                                                </td>
                                                                <td>{item.rollNumber}</td>
                                                                <td>{
                                                                    !this.state.reloadDropdown ?
                                                                        <div className="section-select">
                                                                            <div className="section-dropdown">
                                                                                <Dropdown
                                                                                    key={item._id}
                                                                                    placeholder='Select'
                                                                                    options={this.state?.sectionDropdown}
                                                                                    onSelect={(option) => this.onSelectSection(option, index)}
                                                                                    text={"title"}
                                                                                    style={{ background: "#F6F7F5" }}
                                                                                    value={item.sectionId || ""}
                                                                                    invalid={this.state.isSubmit && !item.sectionId}
                                                                                />
                                                                            </div>
                                                                        </div> : ""
                                                                }</td>
                                                            </tr>
                                                        ))
                                                        : <tr className="bg-white pt-4"><td colSpan="4" align='center'>No Records found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {this.state.studentList?.length ?
                                        <div className="text-center py-4">
                                            {
                                                this.state.validation ?
                                                    <button className={`cw-button-primary `} onClick={this.onClickDelete}>CONTINUE & DELETE SECTION</button>
                                                    :
                                                    <button className={`cw-button-primary disable-button`} onClick={this.onClickDelete}>CONTINUE & DELETE SECTION</button>
                                            }
                                        </div>
                                        : ""}
                                </div>

                        }

                        {
                            this.state.showAddNewTeacher ? this.renderAddNewContactModal() : ""
                        }
                    </div>
                </ModalBody>

            </Modal >
        );
    }
}

export default DeleteTeacher;